import RatingDropdown from './RatingDropdown'

export default RatingDropdown
export { DEFAULT_TITLE as RATING_TITLE } from './RatingDropdown'
